import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 6h-9a6 6 0 1 0 0 12h9","key":"svg-0"}],["path",{"d":"M13 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0","key":"svg-1"}],["path",{"d":"M13 12h7","key":"svg-2"}]]

const IconCapRounded = createReactComponent('outline', 'cap-rounded', 'CapRounded', __iconNode);

export default IconCapRounded;